import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b0568d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StatisticalEvent" }
const _hoisted_2 = { class: "statitiscal" }
const _hoisted_3 = { class: "pv" }
const _hoisted_4 = { class: "uv" }
const _hoisted_5 = { class: "ip" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {secondToString} from '@/utils/date-format'
import {getPageListData} from '@/service/main/system'
import {ref} from 'vue'
import {queryStatistical} from '@/service/main/live/statitiscal'

import {useStore} from '@/store'
import {useRouter} from 'vue-router'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticalEvent',
  setup(__props) {

const store = useStore()

const queryParam = {
  accessTime: [
    dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ]
}
store.commit('system/changeQueyryInfo', queryParam)

const getEventList = async () => {
  let roleData = await getPageListData(
    '/main/customerEvents/queryByCondition',
    {
      pageNo: 1,
      pageSize: 1000
    }
  )

  const channels = searchFormConfig.formItems.find(
    (item) => item.field === 'channelId'
  )
  channels!.options = roleData.list.map((item: any) => {
    return {title: item.eventName, value: item.rowId}
  })
}

getEventList()

const resetCb = () => {
  return queryParam
}

const router = useRouter()

const handleChannel = (item: any) => {
  router.push({
    path: '/main/live/record',
    query: {
      channelId: item.channelId,
      accessTime: store.state.system.queryInfo.accessTime
    }
  })
}
const statitiscal = ref({pv: 0, uv: 0, ip: 0})

const searchCb = async (item: any) => {
  statitiscal.value = await queryStatistical(item)
}

searchCb({...queryParam, pageNo: 1, pageSize: 1000})

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(
  resetCb,
  searchCb
)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode("总访问次数(pv): "),
        _createElementVNode("em", null, _toDisplayString(statitiscal.value.pv), 1)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createTextVNode("客户数量(uv): "),
        _createElementVNode("em", null, _toDisplayString(statitiscal.value.uv), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createTextVNode("独立ip: "),
        _createElementVNode("em", null, _toDisplayString(statitiscal.value.ip), 1)
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "liveStatisticalEvent",
      onRowClick: handleChannel,
      downFilename: "直播访问记录表-按直播间.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick)
    }, {
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(scope.row.duration)), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})